import * as React from 'react';

interface ReasoningProps {
  reasoning: string;
}

export const Reasoning: React.FC<ReasoningProps> = ({ reasoning }) => (
  <div className='mt-2'>
    <div className='mb-1 text-xs text-gray-500'>Reasoning:</div>
    <div className='rounded border bg-blue-50 p-2 text-xs text-blue-800'>{reasoning}</div>
  </div>
);
